var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"look-complete-data-box"},[_c('div',{staticClass:"look-complete-data"},[_c('div',{staticClass:"font-icon",on:{"click":_vm.closeChildAlert}},[_c('span',{staticClass:"iconfont"},[_vm._v("")])]),_c('div',{staticStyle:{"height":"240px"},attrs:{"id":"lookCompleteDataZujian"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }